import * as types from 'actions/types';
import { createReducer, successType } from 'shared/lib/lib/callAPI';

const dataReducer = (state = null, action) => {
  switch (action.type) {
    case successType(types.GET_PSEUDONYMIZATION):
    case successType(types.START_PSEUDONYMIZATION):
    case successType(types.CANCEL_PSEUDONYMIZATION):
      return action.response;
    case types.LOGOUT:
      return { state: 'none', process: null };
    default:
      return state;
  }
};

export default createReducer([
  types.GET_PSEUDONYMIZATION,
  types.START_PSEUDONYMIZATION,
  types.CANCEL_PSEUDONYMIZATION,
], dataReducer);
